import update from 'immutability-helper';

import { LocationListType } from '../../../@types/api-types';
import {
  ChartListType,
  GaugeListType,
  ReducerHookActionType,
} from '../../../@types';
import { sharedReducerHookActionTypes } from '../../../utils/constants';

export const initState: StateType = {
  loading: true,
  locationDetails: {},
  gaugeList: [],
  gaugeDateTime: '',
  chartList: [],
};

export type StateType = {
  loading: boolean;
  locationDetails: Partial<LocationListType>;
  overallAqiIndex?: number;
  gaugeList: GaugeListType[];
  gaugeDateTime: string;
  chartList: ChartListType[];
};

export const actionTypes = {
  ...sharedReducerHookActionTypes,
};

export const reducer = (state: StateType, action: ReducerHookActionType) => {
  switch (action.type) {
    case actionTypes.setState: {
      const updatedState = update(state, {
        $merge: { ...action.payload },
      });
      return { ...updatedState };
    }

    default:
      return { ...state };
  }
};
